(function () {
document.addEventListener("DOMContentLoaded", function() {
    var _loop = function(i) {
        var loadGrid = function loadGrid(id) {
            contentTabWrapper.classList.add("content-tabs__content-wrapper--fade-out");
            var activeWrapper = section.querySelector(".content-tabs__content-wrapper--active");
            var newActive = section.querySelector("#" + id);
            setTimeout(function() {
                activeWrapper.classList.remove("content-tabs__content-wrapper--active");
                newActive.classList.add("content-tabs__content-wrapper--active");
                contentTabWrapper.classList.remove("content-tabs__content-wrapper--fade-out");
                contentTabWrapper.classList.add("content-tabs__content-wrapper--fade-in");
                setTimeout(function() {
                    contentTabWrapper.classList.remove("content-tabs__content-wrapper--fade-in");
                }, 250);
            }, 250);
        };
        // Variables
        var section = sections[i];
        var tabs = document.querySelectorAll('[role="tab"]');
        var tabList = document.querySelector('[role="tablist"]');
        var tabFocus = 0;
        var contentTabWrapper = section.querySelector(".content-tabs__content-wrapper");
        tabs.forEach(function(tab) {
            tab.addEventListener("click", function() {
                if (!tab.classList.contains("active")) {
                    var activeButton = section.querySelector("button.active");
                    loadGrid(tab.dataset.controls);
                    tab.classList.add("active");
                    activeButton.classList.remove("active");
                }
            });
        });
        tabList.addEventListener("keydown", function(e) {
            if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
                tabs[tabFocus].setAttribute("tabindex", -1);
                if (e.key === "ArrowRight") {
                    tabFocus++;
                    if (tabFocus >= tabs.length) tabFocus = 0;
                } else if (e.key === "ArrowLeft") {
                    tabFocus--;
                    if (tabFocus < 0) tabFocus = tabs.length - 1;
                }
                tabs[tabFocus].setAttribute("tabindex", 0);
                tabs[tabFocus].focus();
            }
        });
    };
    // Variables
    var sections = document.getElementsByClassName("content-tabs");
    // Initializing Items
    for(var i = 0; i < sections.length; i++)_loop(i);
});

})();
//# sourceMappingURL=content-tabs.js.map
